import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/analytics';

const fb_config = {
  apiKey: 'AIzaSyCM87Ll4_XTn_k_rrGrRTNoPQxIulfMtLU',
  authDomain: 'meny-stag.firebaseapp.com',
  projectId: 'meny-stag',
  storageBucket: 'meny-stag.appspot.com',
  messagingSenderId: '977714978420',
  appId: '1:977714978420:web:5130c6ce4677d4a63fbb21',
  measurementId: 'G-2S506DKC2M',
};

const app = firebase.initializeApp(fb_config);

try {
  if (process.env.NODE_ENV == 'production') {
    if (window.location.href.search('meny-app') > -1) {
      firebase.analytics();
    }
  }
} catch (error) {
  console.log('initialize analytics failed');
}

export default app;
